import React, { useContext } from 'react';
import { IconButton, useTheme, Tooltip } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { ColorModeContext } from '../context/ColorModeContext';

interface ThemeShifterProps {
  color?: string;
  size?: 'small' | 'medium' | 'large';
  sx?: React.CSSProperties & Record<string, unknown>;
  'data-testid'?: string;
}

export default function ThemeShifter({
  color,
  size = 'small',
  sx,
  'data-testid': dataTestId,
}: ThemeShifterProps) {
  const theme = useTheme();
  const { toggleColorMode, mode } = useContext(ColorModeContext);

  const iconColor = color || theme.palette.text.secondary;

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        data-testid={dataTestId ?? 'admin-theme-toggle'}
        data-mode={mode}
        onClick={toggleColorMode}
        size={size}
        sx={{
          color: iconColor,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'rotate(15deg) scale(1.1)',
            background:
              theme.palette.mode === 'light'
                ? 'rgba(0,0,0,0.04)'
                : 'rgba(255,255,255,0.08)',
          },
          ...sx,
        }}
      >
        {mode === 'light' ? (
          <DarkModeOutlinedIcon fontSize={size === 'small' ? 'small' : 'medium'} />
        ) : (
          <LightModeOutlinedIcon fontSize={size === 'small' ? 'small' : 'medium'} />
        )}
      </IconButton>
    </Tooltip>
  );
}
